import type { CurrentUserDetails } from '../../types/user';

export const getCurrentUserDetails = (): CurrentUserDetails => {
  try {
    const stored = localStorage.getItem('userDetails');
    if (!stored) return {};
    const parsed = JSON.parse(stored);
    return typeof parsed === 'object' && parsed !== null ? parsed : {};
  } catch {
    return {};
  }
};

export const isSuperAdmin = (): boolean => Boolean(getCurrentUserDetails().is_super_admin);
